module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title28"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429998475_tp01",
      "id": "toctitle25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429998475_p01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART I")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Letter to No One")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429998475_p02",
      "id": "toctitle2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART II")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Postal Box of Memory 1967-1971")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c01",
      "id": "toctitle3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Shoelaces")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c02",
      "id": "toctitle4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Shelter")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c03",
      "id": "toctitle5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Souma")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c04",
      "id": "toctitle6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Hospital")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c05",
      "id": "toctitle7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Lentils")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c06",
      "id": "toctitle8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Pastries")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c07",
      "id": "toctitle9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Return")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c08",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Jerusalem")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c09",
      "id": "toctitle11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Jericho")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c10",
      "id": "toctitle12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Accident")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c11",
      "id": "toctitle13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Zuraiq")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c12",
      "id": "toctitle14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Jalazone Boys’ School")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c13",
      "id": "toctitle15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Balad")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c14",
      "id": "toctitle16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Circumcision")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c15",
      "id": "toctitle17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Jalazone Girls’ School")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c16",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Six Fingers")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c17",
      "id": "toctitle19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Elephant Boo")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429998475_c18",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Home")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429998475_p03",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART III")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Letter to Everyone")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781429998475_fm02",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HISTORICAL NOTE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_aboutAuthorPage",
    attrs: {
      "href": "#/e9781429998475_ata01",
      "id": "toctitle29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("About the Author")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429998475_bm01",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TO LEARN MORE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429998475_bm02",
      "id": "toctitle24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GIVING BACK TO THE WORLD")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429998475_cop01",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-083281ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429998475_toc01.vue
// module id = 63
// module chunks = 0